const STOP_WORDS = new Set([
  "AND",
  "OR",
  "THE",
  "OF",
  "FOR",
  "A",
  "AN",
  "TO",
  "IN",
  "WITH",
]);

const TECH_CODES = {
  DEVELOPEMENT: "DEV",
  DEVELOPMENT: "DEV",
  "DATA SCIENCE AND AIML": "DSA",
  "DATA SCIENCE AND AI ML": "DSA",
  "INFRASTRUCTURE CLOUD": "CLD",
  "HR AND TALENT ACQUISITION": "HRA",
  INTERNSHIP: "INT",
  EDTECH: "EDT",
  "SPORTS TECH": "SPT",
};

const ROLE_CODES = {
  "FULL STACK ENGINEER": "FSE",
  "FULL STACK ENGINEER TRAINEE": "FST",
  "JAVA DEVELOPER": "JVD",
  "PHP DEVELOPER": "PHP",
  "DEVOPS ENGINEER": "OPS",
  "DATA ENGINEER": "DTE",
  "MACHINE LEARNING ENGINEER": "MLE",
  "SOC NETWORK SUPPORT ENGINEER": "SOC",
  "VMWARE ARCHITECT": "VMA",
  "VMWARE ADMINISTRATOR": "VMD",
  "VIRTUAL DESKTOP ENGINEER": "VDE",
  "TALENT PARTNER SPECIALIST": "TPS",
  "SOFTWARE ENGINEER TRAINEE": "SET",
  "TEST ENGINEER": "TST",
  "TEST ENGINEER MANUAL AUTOMATION AND PERFORMANCE": "TST",
  "INFRASTRUCTURE AND CLOUD CONSULTING": "ICC",
  "BDE BDM EDTECH": "BDE",
  "BDE BDM EDTECH MATHS SCHOOLS": "BDE",
  "GROWTH MANAGER": "GRM",
  "GROWTH MANAGER EDTECH": "GRM",
  "SPORTS PERFORMANCE ANALYST": "SPA",
};

const normalize = (value) =>
  String(value || "")
    .toUpperCase()
    .replace(/[–—]/g, "-")
    .replace(/\([^)]*\)/g, " ")
    .replace(/[^A-Z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const letters = (value, length) => {
  const cleaned = normalize(value).replace(/ /g, "");
  return (cleaned + "XXX").slice(0, length);
};

const techCode = (category) => {
  const key = normalize(category);
  if (TECH_CODES[key]) return TECH_CODES[key];
  const words = key.split(" ").filter((word) => word && !STOP_WORDS.has(word));
  if (words.length === 0) return "GEN";
  if (words[0].length >= 3) return words[0].slice(0, 3);
  return letters(words.join(""), 3);
};

const roleCode = (jobTitle) => {
  const key = normalize(jobTitle);
  if (ROLE_CODES[key]) return ROLE_CODES[key];

  const prefix = Object.keys(ROLE_CODES).find(
    (known) => key.startsWith(known) || known.startsWith(key)
  );
  if (prefix) return ROLE_CODES[prefix];

  const words = key.split(" ").filter((word) => word && !STOP_WORDS.has(word));
  if (words[0] && words[0].length >= 3) return words[0].slice(0, 3);
  const initials = words.map((word) => word[0]).join("");
  return letters(initials || key, 3);
};

const sequence = (value, index) => {
  const parsed = Number(value);
  const number = Number.isFinite(parsed) ? parsed + 1 : index + 1;
  return String(Math.max(1, number)).padStart(2, "0").slice(-2);
};

export const toJobId = (category, jobTitle, fallbackId, index = 0) => {
  const id = `${roleCode(jobTitle)}${techCode(category)}${sequence(fallbackId, index)}`
    .toUpperCase()
    .slice(0, 8);
  return id;
};

export const assignJobIds = (jobsByCategory = {}) => {
  const used = new Set();
  return Object.fromEntries(
    Object.entries(jobsByCategory).map(([category, jobs]) => [
      category,
      (jobs || []).map((job, index) => {
        let n = index + 1;
        let jobId = toJobId(category, job.jobTitle, n - 1, index);
        while (used.has(jobId)) {
          n += 1;
          jobId = toJobId(category, job.jobTitle, n - 1, index);
        }
        used.add(jobId);
        return { ...job, jobId };
      }),
    ])
  );
};
